module.exports = __webpack_public_path__ + "img/sankaku_94_red.c8b7e6e0.png";